import { Observable } from 'rxjs';

export type AirportBriefingPdfOutcome =
  | { ok: true; pdf: Blob }
  | { ok: false };

/**
 * Emits one outcome for a PDF request, including request failures and empty
 * completion. Request failures display the existing download notification;
 * empty completion is a silent failure. Unsubscribing cancels observation.
 */
export abstract class AirportBriefingPdfPort {
  abstract getAirportPdf(
    airportId: number,
    handlerId?: number,
  ): Observable<AirportBriefingPdfOutcome>;
}
